// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TJim","left":"styles_left__3_3tT"};